//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  computed,
  input
} from '@angular/core';

//local imports
import { FilterGroupModel } from '@shared/components/filter/data/models/filter-group.model';

@Component({
    selector: 'ng-filter',
    templateUrl: './filter.component.html',
    styleUrl: './filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterComponent  {

  public filterGroups: InputSignal<FilterGroupModel[]> = input<FilterGroupModel[]>(null);
  
  public filtersNode = computed(() => {
    return new FilterGroupModel({
      id: "filter",
      title: "Filters",
      depth: 0,
      children: this.filterGroups()
    });
  });

}
